module.exports = __webpack_public_path__ + "img/logo-portaltelemedicina.ae7b8ae3.png";